module.exports = __webpack_public_path__ + "static/img/icon_cloud2.72c1801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud2.jpg
// module id = QGro
// module chunks = 21